type Message = {
  completed?: string;
  relatedItem?: string;
  empty?: string;
};

type Result = {
  text: string;
  color: string;
  backgroundColor: string;
};

export const getLabelStatus = (
  allItems: number,
  completedItems: number,
  message?: Message
): Result => {
  const status = { text: '', color: '', backgroundColor: '' };

  if (!allItems) {
    status.text = message?.empty || 'Empty';
    status.color = '#1F76C7';
    status.backgroundColor = '#D9ECFD';
  } else {
    const itemsLeft = allItems - completedItems;

    if (!itemsLeft) {
      status.text = message?.completed || 'Completed';
      status.color = '#009E7D';
      status.backgroundColor = '#E3F2EE';
    } else {
      const text = [itemsLeft, 'left'];

      if (!!message?.relatedItem) {
        text.splice(1, 0, message.relatedItem);
      }

      status.text = text.join(' ');
      status.color = '#BE8900';
      status.backgroundColor = 'rgba(240, 177, 16, 0.16)';
    }
  }
  return status;
};
